import paginationReducer from "./slices/PaginationSlice";
import logger from 'redux-logger';
import TabReducer from "./slices/TabSlice";
import DashboardReducer from "./slices/DashboardSlice";

import { configureStore } from '@reduxjs/toolkit';


const Store = configureStore({
  reducer: {
    pagination:paginationReducer,
    tab:TabReducer,
    dashboard:DashboardReducer
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware();
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      middleware.push(logger);
    }
    return middleware;
  },
});
export default Store;
